export const deDKBMenus = (logoUrl) => ({
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/',
            url: logoUrl,
            alt: 'Raisin',
        },
        {
            id: '0d3f65cb-ba91-41f0-9e30-efd906a801f0',
            href: '/register?regflow=dkb_retail',
            url: 'https://www.weltsparen.de/app/uploads/2018/01/dkb-logo.svg',
            alt: 'dkb_retail',
        },
    ],
    navItems: [],
    actionItems: [
        {
            id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
            title: 'Anmelden',
            href: '/login/',
            type: 'login',
        },
    ],
});
//# sourceMappingURL=deMenusDKB.js.map